import { keyframes, styled } from '@mui/material/styles'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material'
import { MEDIA, thinScrollbar } from '../../../../constants'

// Change it to theme base to use the scrollbar
export const AskIaLayoutOuterWrapper = styled(Paper)(`
  height: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  background: transparent;
  scroll-behavior: smooth;
  padding: 15px 10px 15px 15px;

  ${thinScrollbar.styles};
`)

export const CanvasOuterContainer = styled(Box)(`
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    min-width: 0;
    overflow: auto;

    position: relative;
    overflow-y: scroll;
    scroll-behavior: smooth;
    ${thinScrollbar.styles};
`)

export const Workspace = styled('main')(`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  padding: 0;
  width: 100%;
`)

export const PrismHeading = styled('typography')(`
  font-weight: 500;
  font-size: 14px;
  color: #165089;
  display: flex;
  line-height: 1;
  align-items: center;

  & svg {
    margin-left: 8px;
    margin-right: 4px;
  }
`)

export const OuterWrapper = styled(Box)(`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 96px);
  background-color: #fff;
  border-radius: 14px;
`)

export const SelectionPanelHeader = styled(Box)(`
  background-color: #ffffff;
  border-bottom: 0.667px solid rgba(15, 23, 42, 0.09);
  display: flex;
  gap: 12px;
  height: 48px;
  align-items: center;
  padding: 4px 20px 4.667px;
  border-radius: 16px 16px 0 0;
  width: 100%;
  justify-content: space-between;
`)

export const WorkspaceBody = styled(Box)(({ theme }) => `
  display: flex;
  flex: 1 0 0;
  align-items: stretch;
  border-radius: 20px;
  min-height: 0;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`);

export const ResultData = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: 20px;

  & .reportHeading {width: 100%; padding-bottom:10px;}
  // & .DriverDownloadPPT.theme1.typeDrivers {overflow: hidden; width: 100%;}
  
  & .reportOuterWrapper {margin-bottom: 20px;}

`);